












import { Vue } from "vue-property-decorator";

/**
 * 現場のプロパティキーの一覧ページ
 */
export default class ProjectPropertyList extends Vue {
  list = [
    { name: "単位", link: "/admin/unit/" },
    { name: "経費カテゴリ", link: "/admin/expense-categories/" },
    { name: "各Noを追加", link: "/admin/project/property/keys/" },
    {
      name: "写真フォルダテンプレート",
      link: "/admin/project/folder-default/image/"
    },
    {
      name: "図面フォルダテンプレート",
      link: "/admin/project/folder-default/draw/"
    },
    {
      name: "タスクデフォルト日数設定",
      link: "/admin/project/task-default/"
    },
    {
      name: "工種名登録",
      link: "/admin/project/construction-type"
    },
    {
      name: "工程表移動チャット",
      link: "/admin/schedule-notification"
    },
    {
      name: "表紙支払い方法テンプレート",
      link: "/admin/project/property/estimate-payment-template"
    }
  ];
}
